import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_card_space_3_card_texte_1Texte, id_card_space_3_card_texte_1CouleurTexte, id_card_space_3_card_texte_1Opacite, id_card_space_3_card_texte_1Afficher, id_card_space_3_card_texte_2Texte, id_card_space_3_card_texte_2CouleurTexte, id_card_space_3_card_texte_2Opacite, id_card_space_3_card_texte_2Afficher, id_card_space_3_groupe_etoile_vector_1Id, id_card_space_3_groupe_etoile_vector_1Alt, id_card_space_3_groupe_etoile_vector_1Opacite, id_card_space_3_groupe_etoile_vector_1Afficher, id_card_space_3_groupe_etoile_vector_2Id, id_card_space_3_groupe_etoile_vector_2Alt, id_card_space_3_groupe_etoile_vector_2Opacite, id_card_space_3_groupe_etoile_vector_2Afficher, id_card_space_3_groupe_etoile_vector_3Id, id_card_space_3_groupe_etoile_vector_3Alt, id_card_space_3_groupe_etoile_vector_3Opacite, id_card_space_3_groupe_etoile_vector_3Afficher, id_card_space_3_groupe_etoile_vector_4Id, id_card_space_3_groupe_etoile_vector_4Alt, id_card_space_3_groupe_etoile_vector_4Opacite, id_card_space_3_groupe_etoile_vector_4Afficher, id_card_space_3_groupe_etoile_vector_5Id, id_card_space_3_groupe_etoile_vector_5Alt, id_card_space_3_groupe_etoile_vector_5Opacite, id_card_space_3_groupe_etoile_vector_5Afficher, id_card_space_2_card_texte_1Texte, id_card_space_2_card_texte_1CouleurTexte, id_card_space_2_card_texte_1Opacite, id_card_space_2_card_texte_1Afficher, id_card_space_2_card_texte_2Texte, id_card_space_2_card_texte_2CouleurTexte, id_card_space_2_card_texte_2Opacite, id_card_space_2_card_texte_2Afficher, id_card_space_2_groupe_etoile_vector_1Id, id_card_space_2_groupe_etoile_vector_1Alt, id_card_space_2_groupe_etoile_vector_1Opacite, id_card_space_2_groupe_etoile_vector_1Afficher, id_card_space_2_groupe_etoile_vector_2Id, id_card_space_2_groupe_etoile_vector_2Alt, id_card_space_2_groupe_etoile_vector_2Opacite, id_card_space_2_groupe_etoile_vector_2Afficher, id_card_space_2_groupe_etoile_vector_3Id, id_card_space_2_groupe_etoile_vector_3Alt, id_card_space_2_groupe_etoile_vector_3Opacite, id_card_space_2_groupe_etoile_vector_3Afficher, id_card_space_2_groupe_etoile_vector_4Id, id_card_space_2_groupe_etoile_vector_4Alt, id_card_space_2_groupe_etoile_vector_4Opacite, id_card_space_2_groupe_etoile_vector_4Afficher, id_card_space_2_groupe_etoile_vector_5Id, id_card_space_2_groupe_etoile_vector_5Alt, id_card_space_2_groupe_etoile_vector_5Opacite, id_card_space_2_groupe_etoile_vector_5Afficher, id_card_space_1_card_texte_1Texte, id_card_space_1_card_texte_1CouleurTexte, id_card_space_1_card_texte_1Opacite, id_card_space_1_card_texte_1Afficher, id_card_space_1_card_texte_2Texte, id_card_space_1_card_texte_2CouleurTexte, id_card_space_1_card_texte_2Opacite, id_card_space_1_card_texte_2Afficher, id_card_space_1_groupe_etoile_vector_1Id, id_card_space_1_groupe_etoile_vector_1Alt, id_card_space_1_groupe_etoile_vector_1Opacite, id_card_space_1_groupe_etoile_vector_1Afficher, id_card_space_1_groupe_etoile_vector_2Id, id_card_space_1_groupe_etoile_vector_2Alt, id_card_space_1_groupe_etoile_vector_2Opacite, id_card_space_1_groupe_etoile_vector_2Afficher, id_card_space_1_groupe_etoile_vector_3Id, id_card_space_1_groupe_etoile_vector_3Alt, id_card_space_1_groupe_etoile_vector_3Opacite, id_card_space_1_groupe_etoile_vector_3Afficher, id_card_space_1_groupe_etoile_vector_4Id, id_card_space_1_groupe_etoile_vector_4Alt, id_card_space_1_groupe_etoile_vector_4Opacite, id_card_space_1_groupe_etoile_vector_4Afficher, id_card_space_1_groupe_etoile_vector_5Id, id_card_space_1_groupe_etoile_vector_5Alt, id_card_space_1_groupe_etoile_vector_5Opacite, id_card_space_1_groupe_etoile_vector_5Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_card_space_3_groupe_etoile_vector_1ImageUrl, id_card_space_3_groupe_etoile_vector_2ImageUrl, id_card_space_3_groupe_etoile_vector_3ImageUrl, id_card_space_3_groupe_etoile_vector_4ImageUrl, id_card_space_3_groupe_etoile_vector_5ImageUrl, id_card_space_2_groupe_etoile_vector_1ImageUrl, id_card_space_2_groupe_etoile_vector_2ImageUrl, id_card_space_2_groupe_etoile_vector_3ImageUrl, id_card_space_2_groupe_etoile_vector_4ImageUrl, id_card_space_2_groupe_etoile_vector_5ImageUrl, id_card_space_1_groupe_etoile_vector_1ImageUrl, id_card_space_1_groupe_etoile_vector_2ImageUrl, id_card_space_1_groupe_etoile_vector_3ImageUrl, id_card_space_1_groupe_etoile_vector_4ImageUrl, id_card_space_1_groupe_etoile_vector_5ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_card_space_3_groupe_etoile_vector_1ImageUrl: id_card_space_3_groupe_etoile_vector_1Id ? media.getMedia( id_card_space_3_groupe_etoile_vector_1Id )?.source_url : null,
            id_card_space_3_groupe_etoile_vector_2ImageUrl: id_card_space_3_groupe_etoile_vector_2Id ? media.getMedia( id_card_space_3_groupe_etoile_vector_2Id )?.source_url : null,
            id_card_space_3_groupe_etoile_vector_3ImageUrl: id_card_space_3_groupe_etoile_vector_3Id ? media.getMedia( id_card_space_3_groupe_etoile_vector_3Id )?.source_url : null,
            id_card_space_3_groupe_etoile_vector_4ImageUrl: id_card_space_3_groupe_etoile_vector_4Id ? media.getMedia( id_card_space_3_groupe_etoile_vector_4Id )?.source_url : null,
            id_card_space_3_groupe_etoile_vector_5ImageUrl: id_card_space_3_groupe_etoile_vector_5Id ? media.getMedia( id_card_space_3_groupe_etoile_vector_5Id )?.source_url : null,
            id_card_space_2_groupe_etoile_vector_1ImageUrl: id_card_space_2_groupe_etoile_vector_1Id ? media.getMedia( id_card_space_2_groupe_etoile_vector_1Id )?.source_url : null,
            id_card_space_2_groupe_etoile_vector_2ImageUrl: id_card_space_2_groupe_etoile_vector_2Id ? media.getMedia( id_card_space_2_groupe_etoile_vector_2Id )?.source_url : null,
            id_card_space_2_groupe_etoile_vector_3ImageUrl: id_card_space_2_groupe_etoile_vector_3Id ? media.getMedia( id_card_space_2_groupe_etoile_vector_3Id )?.source_url : null,
            id_card_space_2_groupe_etoile_vector_4ImageUrl: id_card_space_2_groupe_etoile_vector_4Id ? media.getMedia( id_card_space_2_groupe_etoile_vector_4Id )?.source_url : null,
            id_card_space_2_groupe_etoile_vector_5ImageUrl: id_card_space_2_groupe_etoile_vector_5Id ? media.getMedia( id_card_space_2_groupe_etoile_vector_5Id )?.source_url : null,
            id_card_space_1_groupe_etoile_vector_1ImageUrl: id_card_space_1_groupe_etoile_vector_1Id ? media.getMedia( id_card_space_1_groupe_etoile_vector_1Id )?.source_url : null,
            id_card_space_1_groupe_etoile_vector_2ImageUrl: id_card_space_1_groupe_etoile_vector_2Id ? media.getMedia( id_card_space_1_groupe_etoile_vector_2Id )?.source_url : null,
            id_card_space_1_groupe_etoile_vector_3ImageUrl: id_card_space_1_groupe_etoile_vector_3Id ? media.getMedia( id_card_space_1_groupe_etoile_vector_3Id )?.source_url : null,
            id_card_space_1_groupe_etoile_vector_4ImageUrl: id_card_space_1_groupe_etoile_vector_4Id ? media.getMedia( id_card_space_1_groupe_etoile_vector_4Id )?.source_url : null,
            id_card_space_1_groupe_etoile_vector_5ImageUrl: id_card_space_1_groupe_etoile_vector_5Id ? media.getMedia( id_card_space_1_groupe_etoile_vector_5Id )?.source_url : null
        };
    }, [ blocImageFondId, id_card_space_3_groupe_etoile_vector_1Id, id_card_space_3_groupe_etoile_vector_2Id, id_card_space_3_groupe_etoile_vector_3Id, id_card_space_3_groupe_etoile_vector_4Id, id_card_space_3_groupe_etoile_vector_5Id, id_card_space_2_groupe_etoile_vector_1Id, id_card_space_2_groupe_etoile_vector_2Id, id_card_space_2_groupe_etoile_vector_3Id, id_card_space_2_groupe_etoile_vector_4Id, id_card_space_2_groupe_etoile_vector_5Id, id_card_space_1_groupe_etoile_vector_1Id, id_card_space_1_groupe_etoile_vector_2Id, id_card_space_1_groupe_etoile_vector_3Id, id_card_space_1_groupe_etoile_vector_4Id, id_card_space_1_groupe_etoile_vector_5Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_3_card_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_card_space_3_card_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_space_3_card_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_space_3_card_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_3_card_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_card_space_3_card_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-2 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_3_card_texte_2Afficher}
                        onChange={(val) => setAttributes({ id_card_space_3_card_texte_2Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_space_3_card_texte_2CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_space_3_card_texte_2CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_3_card_texte_2Opacite}
                        onChange={(val) => setAttributes({ id_card_space_3_card_texte_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_3_groupe_etoile_vector_1Afficher}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_3_groupe_etoile_vector_1Alt}
                            onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_3_groupe_etoile_vector_1Opacite}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_3_groupe_etoile_vector_2Afficher}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_3_groupe_etoile_vector_2Alt}
                            onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_3_groupe_etoile_vector_2Opacite}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_3_groupe_etoile_vector_3Afficher}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_3Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_3_groupe_etoile_vector_3Alt}
                            onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_3Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_3_groupe_etoile_vector_3Opacite}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_3Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_3_groupe_etoile_vector_4Afficher}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_4Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_3_groupe_etoile_vector_4Alt}
                            onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_4Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_3_groupe_etoile_vector_4Opacite}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_4Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_3_groupe_etoile_vector_5Afficher}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_5Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_3_groupe_etoile_vector_5Alt}
                            onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_5Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_3_groupe_etoile_vector_5Opacite}
                        onChange={(val) => setAttributes({ id_card_space_3_groupe_etoile_vector_5Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_2_card_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_card_space_2_card_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_space_2_card_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_space_2_card_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_2_card_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_card_space_2_card_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-2 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_2_card_texte_2Afficher}
                        onChange={(val) => setAttributes({ id_card_space_2_card_texte_2Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_space_2_card_texte_2CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_space_2_card_texte_2CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_2_card_texte_2Opacite}
                        onChange={(val) => setAttributes({ id_card_space_2_card_texte_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_2_groupe_etoile_vector_1Afficher}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_2_groupe_etoile_vector_1Alt}
                            onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_2_groupe_etoile_vector_1Opacite}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_2_groupe_etoile_vector_2Afficher}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_2_groupe_etoile_vector_2Alt}
                            onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_2_groupe_etoile_vector_2Opacite}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_2_groupe_etoile_vector_3Afficher}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_3Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_2_groupe_etoile_vector_3Alt}
                            onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_3Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_2_groupe_etoile_vector_3Opacite}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_3Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_2_groupe_etoile_vector_4Afficher}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_4Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_2_groupe_etoile_vector_4Alt}
                            onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_4Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_2_groupe_etoile_vector_4Opacite}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_4Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_2_groupe_etoile_vector_5Afficher}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_5Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_2_groupe_etoile_vector_5Alt}
                            onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_5Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_2_groupe_etoile_vector_5Opacite}
                        onChange={(val) => setAttributes({ id_card_space_2_groupe_etoile_vector_5Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_1_card_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_card_space_1_card_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_space_1_card_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_space_1_card_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_1_card_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_card_space_1_card_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-2 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_1_card_texte_2Afficher}
                        onChange={(val) => setAttributes({ id_card_space_1_card_texte_2Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_card_space_1_card_texte_2CouleurTexte}
                            onChange={(val) => setAttributes({ id_card_space_1_card_texte_2CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_1_card_texte_2Opacite}
                        onChange={(val) => setAttributes({ id_card_space_1_card_texte_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_1_groupe_etoile_vector_1Afficher}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_1_groupe_etoile_vector_1Alt}
                            onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_1_groupe_etoile_vector_1Opacite}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_1_groupe_etoile_vector_2Afficher}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_1_groupe_etoile_vector_2Alt}
                            onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_1_groupe_etoile_vector_2Opacite}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_1_groupe_etoile_vector_3Afficher}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_3Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_1_groupe_etoile_vector_3Alt}
                            onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_3Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_1_groupe_etoile_vector_3Opacite}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_3Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_1_groupe_etoile_vector_4Afficher}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_4Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_1_groupe_etoile_vector_4Alt}
                            onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_4Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_1_groupe_etoile_vector_4Opacite}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_4Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Vector (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_card_space_1_groupe_etoile_vector_5Afficher}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_5Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_card_space_1_groupe_etoile_vector_5Alt}
                            onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_5Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_card_space_1_groupe_etoile_vector_5Opacite}
                        onChange={(val) => setAttributes({ id_card_space_1_groupe_etoile_vector_5Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div className="container-fluid">
                    <div className="row">
                        {/* id_card_space_1 */}
                        <div className="col-12 col-lg-4">
                            {/* id_card_space_1_groupe_etoile */}
                            <div>
                                {/* id_card_space_1_groupe_etoile_vector_1 */}
                                {id_card_space_1_groupe_etoile_vector_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_1_groupe_etoile_vector_1Id: media.id, id_card_space_1_groupe_etoile_vector_1Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_1_groupe_etoile_vector_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_1_groupe_etoile_vector_1ImageUrl ? (
                                                    <img className="id_card_space_1_groupe_etoile_vector_1" src={id_card_space_1_groupe_etoile_vector_1ImageUrl} alt={id_card_space_1_groupe_etoile_vector_1Alt} style={{ opacity: id_card_space_1_groupe_etoile_vector_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_1_groupe_etoile_vector_1 */}
                                {/* id_card_space_1_groupe_etoile_vector_2 */}
                                {id_card_space_1_groupe_etoile_vector_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_1_groupe_etoile_vector_2Id: media.id, id_card_space_1_groupe_etoile_vector_2Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_1_groupe_etoile_vector_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_1_groupe_etoile_vector_2ImageUrl ? (
                                                    <img className="id_card_space_1_groupe_etoile_vector_2" src={id_card_space_1_groupe_etoile_vector_2ImageUrl} alt={id_card_space_1_groupe_etoile_vector_2Alt} style={{ opacity: id_card_space_1_groupe_etoile_vector_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_1_groupe_etoile_vector_2 */}
                                {/* id_card_space_1_groupe_etoile_vector_3 */}
                                {id_card_space_1_groupe_etoile_vector_3Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_1_groupe_etoile_vector_3Id: media.id, id_card_space_1_groupe_etoile_vector_3Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_1_groupe_etoile_vector_3Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_1_groupe_etoile_vector_3ImageUrl ? (
                                                    <img className="id_card_space_1_groupe_etoile_vector_3" src={id_card_space_1_groupe_etoile_vector_3ImageUrl} alt={id_card_space_1_groupe_etoile_vector_3Alt} style={{ opacity: id_card_space_1_groupe_etoile_vector_3Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_1_groupe_etoile_vector_3 */}
                                {/* id_card_space_1_groupe_etoile_vector_4 */}
                                {id_card_space_1_groupe_etoile_vector_4Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_1_groupe_etoile_vector_4Id: media.id, id_card_space_1_groupe_etoile_vector_4Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_1_groupe_etoile_vector_4Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_1_groupe_etoile_vector_4ImageUrl ? (
                                                    <img className="id_card_space_1_groupe_etoile_vector_4" src={id_card_space_1_groupe_etoile_vector_4ImageUrl} alt={id_card_space_1_groupe_etoile_vector_4Alt} style={{ opacity: id_card_space_1_groupe_etoile_vector_4Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_1_groupe_etoile_vector_4 */}
                                {/* id_card_space_1_groupe_etoile_vector_5 */}
                                {id_card_space_1_groupe_etoile_vector_5Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_1_groupe_etoile_vector_5Id: media.id, id_card_space_1_groupe_etoile_vector_5Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_1_groupe_etoile_vector_5Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_1_groupe_etoile_vector_5ImageUrl ? (
                                                    <img className="id_card_space_1_groupe_etoile_vector_5" src={id_card_space_1_groupe_etoile_vector_5ImageUrl} alt={id_card_space_1_groupe_etoile_vector_5Alt} style={{ opacity: id_card_space_1_groupe_etoile_vector_5Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_1_groupe_etoile_vector_5 */}
                            </div>
                            {/* end-id_card_space_1_groupe_etoile */}
                            {/* id_card_space_1_card */}
                            <div>
                                {/* id_card_space_1_card_texte_1 */}
                                {id_card_space_1_card_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_card_space_1_card_texte_1 " 
                                        value={id_card_space_1_card_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_card_space_1_card_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_card_space_1_card_texte_1CouleurTexte, opacity: id_card_space_1_card_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_card_space_1_card_texte_1 */}
                                {/* id_card_space_1_card_texte_2 */}
                                {id_card_space_1_card_texte_2Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_card_space_1_card_texte_2 " 
                                        value={id_card_space_1_card_texte_2Texte} 
                                        onChange={(val) => setAttributes({ id_card_space_1_card_texte_2Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_card_space_1_card_texte_2CouleurTexte, opacity: id_card_space_1_card_texte_2Opacite }} 
                                    />
                                )}
                                {/* end-id_card_space_1_card_texte_2 */}
                            </div>
                            {/* end-id_card_space_1_card */}
                        </div>
                        {/* end-id_card_space_1 */}
                        {/* id_card_space_2 */}
                        <div className="col-12 col-lg-4">
                            {/* id_card_space_2_groupe_etoile */}
                            <div>
                                {/* id_card_space_2_groupe_etoile_vector_1 */}
                                {id_card_space_2_groupe_etoile_vector_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_2_groupe_etoile_vector_1Id: media.id, id_card_space_2_groupe_etoile_vector_1Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_2_groupe_etoile_vector_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_2_groupe_etoile_vector_1ImageUrl ? (
                                                    <img className="id_card_space_2_groupe_etoile_vector_1" src={id_card_space_2_groupe_etoile_vector_1ImageUrl} alt={id_card_space_2_groupe_etoile_vector_1Alt} style={{ opacity: id_card_space_2_groupe_etoile_vector_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_2_groupe_etoile_vector_1 */}
                                {/* id_card_space_2_groupe_etoile_vector_2 */}
                                {id_card_space_2_groupe_etoile_vector_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_2_groupe_etoile_vector_2Id: media.id, id_card_space_2_groupe_etoile_vector_2Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_2_groupe_etoile_vector_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_2_groupe_etoile_vector_2ImageUrl ? (
                                                    <img className="id_card_space_2_groupe_etoile_vector_2" src={id_card_space_2_groupe_etoile_vector_2ImageUrl} alt={id_card_space_2_groupe_etoile_vector_2Alt} style={{ opacity: id_card_space_2_groupe_etoile_vector_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_2_groupe_etoile_vector_2 */}
                                {/* id_card_space_2_groupe_etoile_vector_3 */}
                                {id_card_space_2_groupe_etoile_vector_3Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_2_groupe_etoile_vector_3Id: media.id, id_card_space_2_groupe_etoile_vector_3Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_2_groupe_etoile_vector_3Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_2_groupe_etoile_vector_3ImageUrl ? (
                                                    <img className="id_card_space_2_groupe_etoile_vector_3" src={id_card_space_2_groupe_etoile_vector_3ImageUrl} alt={id_card_space_2_groupe_etoile_vector_3Alt} style={{ opacity: id_card_space_2_groupe_etoile_vector_3Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_2_groupe_etoile_vector_3 */}
                                {/* id_card_space_2_groupe_etoile_vector_4 */}
                                {id_card_space_2_groupe_etoile_vector_4Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_2_groupe_etoile_vector_4Id: media.id, id_card_space_2_groupe_etoile_vector_4Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_2_groupe_etoile_vector_4Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_2_groupe_etoile_vector_4ImageUrl ? (
                                                    <img className="id_card_space_2_groupe_etoile_vector_4" src={id_card_space_2_groupe_etoile_vector_4ImageUrl} alt={id_card_space_2_groupe_etoile_vector_4Alt} style={{ opacity: id_card_space_2_groupe_etoile_vector_4Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_2_groupe_etoile_vector_4 */}
                                {/* id_card_space_2_groupe_etoile_vector_5 */}
                                {id_card_space_2_groupe_etoile_vector_5Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_2_groupe_etoile_vector_5Id: media.id, id_card_space_2_groupe_etoile_vector_5Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_2_groupe_etoile_vector_5Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_2_groupe_etoile_vector_5ImageUrl ? (
                                                    <img className="id_card_space_2_groupe_etoile_vector_5" src={id_card_space_2_groupe_etoile_vector_5ImageUrl} alt={id_card_space_2_groupe_etoile_vector_5Alt} style={{ opacity: id_card_space_2_groupe_etoile_vector_5Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_2_groupe_etoile_vector_5 */}
                            </div>
                            {/* end-id_card_space_2_groupe_etoile */}
                            {/* id_card_space_2_card */}
                            <div>
                                {/* id_card_space_2_card_texte_1 */}
                                {id_card_space_2_card_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_card_space_2_card_texte_1 " 
                                        value={id_card_space_2_card_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_card_space_2_card_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_card_space_2_card_texte_1CouleurTexte, opacity: id_card_space_2_card_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_card_space_2_card_texte_1 */}
                                {/* id_card_space_2_card_texte_2 */}
                                {id_card_space_2_card_texte_2Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_card_space_2_card_texte_2 " 
                                        value={id_card_space_2_card_texte_2Texte} 
                                        onChange={(val) => setAttributes({ id_card_space_2_card_texte_2Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_card_space_2_card_texte_2CouleurTexte, opacity: id_card_space_2_card_texte_2Opacite }} 
                                    />
                                )}
                                {/* end-id_card_space_2_card_texte_2 */}
                            </div>
                            {/* end-id_card_space_2_card */}
                        </div>
                        {/* end-id_card_space_2 */}
                        {/* id_card_space_3 */}
                        <div className="col-12 col-lg-4">
                            {/* id_card_space_3_groupe_etoile */}
                            <div>
                                {/* id_card_space_3_groupe_etoile_vector_1 */}
                                {id_card_space_3_groupe_etoile_vector_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_3_groupe_etoile_vector_1Id: media.id, id_card_space_3_groupe_etoile_vector_1Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_3_groupe_etoile_vector_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_3_groupe_etoile_vector_1ImageUrl ? (
                                                    <img className="id_card_space_3_groupe_etoile_vector_1" src={id_card_space_3_groupe_etoile_vector_1ImageUrl} alt={id_card_space_3_groupe_etoile_vector_1Alt} style={{ opacity: id_card_space_3_groupe_etoile_vector_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_3_groupe_etoile_vector_1 */}
                                {/* id_card_space_3_groupe_etoile_vector_2 */}
                                {id_card_space_3_groupe_etoile_vector_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_3_groupe_etoile_vector_2Id: media.id, id_card_space_3_groupe_etoile_vector_2Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_3_groupe_etoile_vector_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_3_groupe_etoile_vector_2ImageUrl ? (
                                                    <img className="id_card_space_3_groupe_etoile_vector_2" src={id_card_space_3_groupe_etoile_vector_2ImageUrl} alt={id_card_space_3_groupe_etoile_vector_2Alt} style={{ opacity: id_card_space_3_groupe_etoile_vector_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_3_groupe_etoile_vector_2 */}
                                {/* id_card_space_3_groupe_etoile_vector_3 */}
                                {id_card_space_3_groupe_etoile_vector_3Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_3_groupe_etoile_vector_3Id: media.id, id_card_space_3_groupe_etoile_vector_3Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_3_groupe_etoile_vector_3Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_3_groupe_etoile_vector_3ImageUrl ? (
                                                    <img className="id_card_space_3_groupe_etoile_vector_3" src={id_card_space_3_groupe_etoile_vector_3ImageUrl} alt={id_card_space_3_groupe_etoile_vector_3Alt} style={{ opacity: id_card_space_3_groupe_etoile_vector_3Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_3_groupe_etoile_vector_3 */}
                                {/* id_card_space_3_groupe_etoile_vector_4 */}
                                {id_card_space_3_groupe_etoile_vector_4Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_3_groupe_etoile_vector_4Id: media.id, id_card_space_3_groupe_etoile_vector_4Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_3_groupe_etoile_vector_4Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_3_groupe_etoile_vector_4ImageUrl ? (
                                                    <img className="id_card_space_3_groupe_etoile_vector_4" src={id_card_space_3_groupe_etoile_vector_4ImageUrl} alt={id_card_space_3_groupe_etoile_vector_4Alt} style={{ opacity: id_card_space_3_groupe_etoile_vector_4Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_3_groupe_etoile_vector_4 */}
                                {/* id_card_space_3_groupe_etoile_vector_5 */}
                                {id_card_space_3_groupe_etoile_vector_5Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_card_space_3_groupe_etoile_vector_5Id: media.id, id_card_space_3_groupe_etoile_vector_5Alt: media.alt })}
                                        type="image"
                                        value={id_card_space_3_groupe_etoile_vector_5Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_card_space_3_groupe_etoile_vector_5ImageUrl ? (
                                                    <img className="id_card_space_3_groupe_etoile_vector_5" src={id_card_space_3_groupe_etoile_vector_5ImageUrl} alt={id_card_space_3_groupe_etoile_vector_5Alt} style={{ opacity: id_card_space_3_groupe_etoile_vector_5Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_card_space_3_groupe_etoile_vector_5 */}
                            </div>
                            {/* end-id_card_space_3_groupe_etoile */}
                            {/* id_card_space_3_card */}
                            <div>
                                {/* id_card_space_3_card_texte_1 */}
                                {id_card_space_3_card_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_card_space_3_card_texte_1 " 
                                        value={id_card_space_3_card_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_card_space_3_card_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_card_space_3_card_texte_1CouleurTexte, opacity: id_card_space_3_card_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_card_space_3_card_texte_1 */}
                                {/* id_card_space_3_card_texte_2 */}
                                {id_card_space_3_card_texte_2Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_card_space_3_card_texte_2 " 
                                        value={id_card_space_3_card_texte_2Texte} 
                                        onChange={(val) => setAttributes({ id_card_space_3_card_texte_2Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_card_space_3_card_texte_2CouleurTexte, opacity: id_card_space_3_card_texte_2Opacite }} 
                                    />
                                )}
                                {/* end-id_card_space_3_card_texte_2 */}
                            </div>
                            {/* end-id_card_space_3_card */}
                        </div>
                        {/* end-id_card_space_3 */}
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}